import { useTranslation } from "react-i18next";
import type { ContactImportReportQuery } from "./contact-import-report-query.js";
import { useReportFiltersSheet } from "./ReportFilterSheet.js";
import { ReportToolbarRow } from "./ReportToolbarRow.js";

export function ContactImportReportToolbar({
  query,
  dateFrom,
  dateTo,
  filteredTotal,
  filtersActive,
  onSearchChange,
  onDateRangeChange,
  onResetFilters,
  columnsSlot,
}: {
  query: ContactImportReportQuery;
  dateFrom: string;
  dateTo: string;
  filteredTotal: number | null;
  filtersActive: boolean;
  onSearchChange: (value: string) => void;
  onDateRangeChange: (from: string, to: string) => void;
  onResetFilters: () => void;
  columnsSlot?: React.ReactNode;
}): React.JSX.Element {
  const { t, i18n } = useTranslation();
  const { filtersOpen, setFiltersOpen } = useReportFiltersSheet();

  return (
    <ReportToolbarRow
      toolbarTestId="reports-contact-imports-toolbar"
      search={query.search}
      onSearchChange={onSearchChange}
      searchPlaceholder={t("reports.contactImports.searchPlaceholder")}
      searchTestId="reports-contact-imports-search"
      dateFrom={dateFrom}
      dateTo={dateTo}
      onDateRangeChange={onDateRangeChange}
      fromTestId="reports-contact-imports-from"
      toTestId="reports-contact-imports-to"
      columnsSlot={columnsSlot}
      mobileFiltersOpen={filtersOpen}
      onMobileFiltersOpenChange={setFiltersOpen}
      mobileFiltersTitle={t("reports.contactImports.filtersTitle")}
      mobileFiltersDescription={t("reports.contactImports.filtersDescription")}
      mobileFiltersTestId="reports-contact-imports-filters-sheet"
      mobileFiltersOpenTestId="reports-contact-imports-open-filters"
      mobileFiltersBody={null}
      filtersActive={filtersActive}
      explicitDateFrom={query.from}
      explicitDateTo={query.to}
      onResetFilters={onResetFilters}
      resetTestId="reports-contact-imports-reset"
      filteredCountSlot={
        filteredTotal != null ? (
          <p
            className="m-0 flex h-8 shrink-0 items-center whitespace-nowrap text-[0.75rem] text-muted"
            data-testid="reports-contact-imports-filtered-count"
          >
            {t("reports.contactImports.filteredCount", {
              formatted: new Intl.NumberFormat(i18n.language).format(filteredTotal),
            })}
          </p>
        ) : null
      }
    />
  );
}
